<div class="modal fade show" id="exampleModalLive" tabindex="-1" aria-labelledby="exampleModalLiveLabel"
    style="display: block; padding-right: 17px;" aria-modal="true" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLiveLabel">
                    {{this.data.header}}
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="this.cancel()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <p>{{this.data.body_text}}</p>
            </div>
            <div class="modal-footer">
                <button *ngIf="this.data.cancel_btn_display" type="button" class="{{this.data.cancel_btn_class}}"
                    data-dismiss="modal" (click)="this.cancel()">
                    {{this.data.cancel_btn_label}}
                </button>
                <button *ngIf="this.data.confirm_btn_display" type="button" class="{{this.data.confirm_btn_class}}"
                    (click)="this.confirm()">
                    {{this.data.confirm_btn_label}}
                </button>
            </div>
        </div>
    </div>
</div>